module.exports = __webpack_public_path__ + "img/print.1fa1bf71.gif";